import styled from "styled-components";
import { MAIN_COLORS } from "../../../../../../constants/vetrina/Colors";
import {
  DIMENS,
  MOBILE_BREAKPOINT,
} from "../../../../../../constants/vetrina/Dimens";
import { transitionCubic1 } from "../../../../../../constants/vetrina/Anims";

export const StyledMobileWorkerDetail = styled.div`
  background-color: ${MAIN_COLORS.white};
  position: fixed;
  bottom: 0;
  width: 100vw;
  border-radius: ${DIMENS.borderRadius4} ${DIMENS.borderRadius4} 0 0;
  height: 90vh;
  animation: slideUp 0.2s;
  padding-inline: 1rem;
  overflow-y: scroll;
  padding-bottom: 12rem;

  .field {
    margin: 1rem;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .sheet-header {
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .secondary-title {
    font-size: 1rem;
    margin-bottom: 0.5rem;
    margin-top: 2rem;
    line-height: 1.5rem;
    display: flex;
    align-items: center;
    color: ${MAIN_COLORS.black};
    cursor: pointer;

    img {
      margin-left: 0.625rem;
      height: 0.7rem;
      width: 0.7rem;
    }
  }

  .dropdown {
    list-style: none;
    height: auto;
    max-height: 0rem;
    overflow: hidden;
    transform: scaleY(0);
    transform-origin: top;
    opacity: 0;
    ${transitionCubic1}
  }

  .opened {
    max-height: 1000rem;
    transform: scaleY(1);
    opacity: 1;
  }

  .details {
    margin-top: 1.5rem;

    p {
      font-family: "Inter", sans-serif;
      font-size: 1rem;
    }
  }

  .skills {
    margin-block: 1.5rem;

    ul {
      list-style: none;
      display: grid;
      grid-auto-flow: row;
      grid-gap: 0.33rem;

      li {
        p {
          font-family: "Inter", sans-serif;
          font-weight: 400;
        }
      }
    }

    .btn-more-skills {
      margin-top: 1rem;
      border: none;
      background-color: transparent;
      text-decoration: underline;
      font-family: inherit;
      color: ${MAIN_COLORS.blue600};
      font-weight: 600;
      line-height: 1.5rem;
      cursor: pointer;
      margin-left: 0.3rem;

      @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
        font-size: 0.75rem;
        line-height: 1.125rem;
      }
    }
  }
`;
